import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import type {RouteObject} from '@github-ui/react-router'
import type {ComponentType} from 'react'

import {workflowRouteParam} from '../workflow-path'
import {buildAllWorkflowRunsRoute} from './all-workflow-runs-route'
import {buildWorkflowRunsRoute} from './workflow-runs-route'
import type {ActionsShellRouteHandle} from './workflows-layout'
import {buildWorkflowsLayoutRoute} from './workflows-layout-route'
import {createActionsRailsFragmentRoutes} from './actions-rails-fragment-routes'

export interface ActionsWorkflowsRouteComponents {
  AllWorkflowRuns: ComponentType
  AllWorkflowRunsError: ComponentType
  WorkflowRuns: ComponentType
  WorkflowRunsError: ComponentType
  WorkflowsLayout: ComponentType
}

const allWorkflowsShell = {
  kind: 'workflow',
  title: 'All workflows',
  getSelection: () => ({type: 'all-workflows'}),
} satisfies ActionsShellRouteHandle

const workflowRunsShell = {
  kind: 'workflow',
  title: 'Workflow runs',
  getSelection: params => ({type: 'workflow', filename: workflowRouteParam(params)}),
} satisfies ActionsShellRouteHandle

/** Builds the Actions Workflows routes for either the standalone or repo app builder. */
export function createActionsWorkflowsRoutes(
  appBuilder: DataRouterApplicationBuilder<string>,
  components: ActionsWorkflowsRouteComponents,
): RouteObject[] {
  const {AllWorkflowRuns, AllWorkflowRunsError, WorkflowRuns, WorkflowRunsError, WorkflowsLayout} = components

  return [
    buildWorkflowsLayoutRoute(appBuilder).toRoute({
      Component: WorkflowsLayout,
      children: [
        buildAllWorkflowRunsRoute(appBuilder).toRoute({
          Component: AllWorkflowRuns,
          handle: {actionsShell: allWorkflowsShell},
          errorBoundary: {fallback: <AllWorkflowRunsError />},
        }),
        buildWorkflowRunsRoute(appBuilder).toRoute({
          Component: WorkflowRuns,
          handle: {actionsShell: workflowRunsShell},
          errorBoundary: {fallback: <WorkflowRunsError />},
        }),
        ...createActionsRailsFragmentRoutes(appBuilder),
      ],
    }),
  ]
}
